(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcements-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const announcementsBar = document.getElementById('announcements-bar');
    if (!announcementsBar) return;

    // El announcements bar ahora funciona completamente automático
    // Los anuncios se desplazan automáticamente con CSS animations
    // No necesita JavaScript para funcionar
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-look"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const productItems = document.querySelectorAll('.featured-product-item');
    const markers = document.querySelectorAll('.product-marker');

    // Función para resaltar producto
    function highlightProduct(productId) {
      // Remover highlight de todos los productos
      productItems.forEach(item => {
        item.classList.remove('highlighted');
      });
      
      // Agregar highlight al producto seleccionado
      const selectedItem = document.querySelector(`[data-product-id="${productId}"]`);
      if (selectedItem) {
        selectedItem.classList.add('highlighted');
      }
    }

    // Event listeners para productos
    productItems.forEach(item => {
      item.addEventListener('click', function() {
        const productId = this.dataset.productId;
        highlightProduct(productId);
      });
    });

    // Event listeners para marcadores
    markers.forEach(marker => {
      marker.addEventListener('click', function() {
        const productId = this.dataset.productId;
        highlightProduct(productId);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
